export default function buttonSize(
  paddingVertical,
  paddingHorizontal,
  borderRadius,
) {
  return `padding: ${paddingVertical} ${paddingHorizontal};
    border-radius: ${borderRadius};`;
}
